import { useEffect } from "react";
import { useSelector } from "react-redux";

import i18n, { LanguageType } from "../../i18n.config";
import { RootState } from "../../store/store";

export const SyncUserLanguage = () => {
  const user = useSelector((state: RootState) => state.user.user);

  useEffect(() => {
    if (!user || user.id === 0) {
      return;
    }

    const locale: LanguageType = user.language === "es" ? "es" : "en";
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
  }, [user?.id, user?.language]);

  return null;
};
